export default __webpack_public_path__ + "static/media/rk6.0d2a41c5.png";